import { Quote } from "lucide-react";
import { STORY_TEXT } from "../data/content";
import { SectionTitle } from "./Brand";
import { Reveal } from "./Reveal";

const Story = () => (
    <section id="a-propos" data-testid="story-section" className="relative py-24 sm:py-32">
        <div className="halo pointer-events-none absolute left-0 top-1/4 h-[22rem] w-[22rem] rounded-full opacity-50" />
        <div className="relative mx-auto max-w-3xl px-4 sm:px-6">
            <Reveal>
                <SectionTitle eyebrow="Notre histoire" title="De la Croisette à votre allée" />
            </Reveal>
            <Reveal delay={0.1}>
                <div className="card-line glow-soft relative rounded-3xl bg-panel p-8 sm:p-12">
                    <Quote
                        size={40}
                        className="absolute -top-5 left-8 rounded-xl border border-neon/25 bg-noir p-2 text-neon"
                    />
                    <p className="text-base leading-relaxed text-slate-300 sm:text-lg">
                        {STORY_TEXT}
                    </p>
                    <p data-testid="story-signature" className="mt-8 font-display text-sm font-bold uppercase tracking-[0.25em] text-neon">
                        — Nassim, fondateur de Clean My Life
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Story;
